import { render, staticRenderFns } from "./AdAccountMaterial.vue?vue&type=template&id=0727bd1b&scoped=true"
import script from "./AdAccountMaterial.vue?vue&type=script&lang=js"
export * from "./AdAccountMaterial.vue?vue&type=script&lang=js"
import style0 from "./AdAccountMaterial.vue?vue&type=style&index=0&id=0727bd1b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0727bd1b",
  null
  
)

export default component.exports